<template>
  <woot-tabs :index="activeIndex" @change="onTabChange">
    <woot-tabs-item
      v-for="tab in tabs"
      :key="tab.routeName"
      :name="tab.name"
      :show-badge="false"
    />
  </woot-tabs>
</template>

<script>
// Shared tab bar for the supervisor surfaces (QM §5.5 overview, §5.9 audit log).
// Both are gated by QueueSupervision, so they live side by side rather than in
// the role-gated settings sidebar.
export default {
  props: {
    // Route name of the currently rendered screen.
    current: {
      type: String,
      required: true,
    },
  },
  computed: {
    tabs() {
      return [
        {
          routeName: 'queues_supervisor',
          name: this.$t('QUEUES_MGMT.SUPERVISOR.TABS.OVERVIEW'),
        },
        {
          routeName: 'queues_audit',
          name: this.$t('QUEUES_MGMT.SUPERVISOR.TABS.AUDIT'),
        },
      ];
    },
    activeIndex() {
      const index = this.tabs.findIndex(tab => tab.routeName === this.current);
      return index === -1 ? 0 : index;
    },
  },
  methods: {
    onTabChange(index) {
      const { routeName } = this.tabs[index];
      if (routeName !== this.current) {
        this.$router.push({ name: routeName });
      }
    },
  },
};
</script>
